import React, { useMemo } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import styles from "../styles/encuesta4c.module.css";

const SELECT_STYLES = {
  control: (base, state) => ({
    ...base,
    minHeight: 36,
    minWidth: 148,
    borderRadius: 10,
    borderColor: state.isFocused ? "#e1147e" : "#e5e7eb",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(225, 20, 126, 0.12)" : "none",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    fontSize: 13,
    cursor: "pointer",
    "&:hover": { borderColor: "#fbcfe8" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 8px" }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, padding: 6, color: "#9ca3af" }),
  menu: (base) => ({
    ...base,
    borderRadius: 10,
    overflow: "hidden",
    boxShadow: "0 12px 28px rgba(31, 41, 55, 0.14)",
    zIndex: 50,
  }),
  option: (base, state) => ({
    ...base,
    fontSize: 13,
    backgroundColor: state.isSelected
      ? "#fdf2f8"
      : state.isFocused
        ? "#fce7f3"
        : "white",
    color: state.isSelected ? "#e1147e" : "#374151",
    cursor: "pointer",
  }),
};

function FlagLabel({ code, text }) {
  return (
    <div className={styles.langOption}>
      <img
        src={`/img/banderas/${code}.png`}
        alt=""
        className={styles.langFlag}
      />
      <span>{text}</span>
    </div>
  );
}

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "es").slice(0, 2);

  const options = useMemo(
    () => [
      {
        value: "es",
        label: <FlagLabel code="es" text={t("spanish")} />,
      },
      {
        value: "en",
        label: <FlagLabel code="en" text={t("english")} />,
      },
    ],
    [t]
  );

  return (
    <div className={styles.changeLanguage}>
      <Select
        options={options}
        placeholder={t("changeLanguage")}
        menuPlacement="top"
        isSearchable={false}
        styles={SELECT_STYLES}
        onChange={(opt) => {
          if (opt?.value) i18n.changeLanguage(opt.value);
        }}
        value={options.find((o) => o.value === lang) || options[0]}
        aria-label={t("changeLanguage")}
      />
    </div>
  );
}
